import { TASK_TEXT } from './text'
import type { BuiltInTaskDefinition } from './types'

export const ROLE_DELETE_TASK: BuiltInTaskDefinition = {
    slug: 'role-delete',
    name: 'Remove a role from a conversation',
    kind: 'llm',
    overlapPolicy: 'skip',
    concurrencySafe: true,
    serializeOn: null,
    builtInRole: 'org_change',
    chatPurpose: null,
    goal: 'Name every member and task that holds a role, write its removal as a plan, and get the CEO’s sign-off; the OS removes the role at their approval only while nothing holds it',
    metric: {
        text: 'Share of role-removal sign-offs that name every holder and task before the CEO decides',
    },
    guardrails: [
        'Propose only — write the plan with os.write_plan; the OS removes the role once the CEO approves, and refuses while anything holds it',
        'Name every member who holds the role and every task assigned to it before asking for sign-off',
        'An empty list is a real answer, but only after looking',
    ],
    inputs: [
        {
            key: 'request',
            label: 'What the CEO wants removed',
            type: 'string',
            required: true,
        },
        {
            key: 'ceoNote',
            label: 'CEO note from a previous round',
            type: 'string',
            required: false,
        },
        {
            key: 'chatSessionId',
            label: 'Chat session this plan belongs to (chat fills it)',
            type: 'string',
            required: false,
        },
        {
            key: 'planKey',
            label: 'The conversation this plan belongs to when it has no chat session (the OS fills it)',
            type: 'string',
            required: false,
        },
    ],
    tools: ['os.directory', 'os.write_plan', 'os.read_plan', 'os.ask_ceo'],
    gates: [
        {
            tool: 'os.ask_ceo',
            owner: 'ceo',
            approval: 'specific',
        },
    ],
    spend: {
        moneyUsdPerRun: 1.5,
        maxModelTier: 'mid',
    },
    workspace: null,
    requiredWrites: null,
    allowSelfReaction: null,
    contextPrefixes: null,
    trainGrants: null,
    finishesOn: null,
    successors: [
        {
            slug: 'role-delete',
            on: 'ceo_approved',
            resumeConversation: true,
        },
        {
            slug: 'role-delete',
            on: 'ceo_changes_requested',
        },
        {
            slug: 'task-self-improvement',
            on: 'terminal',
        },
    ],
    skillMd: TASK_TEXT['role-delete.md'],
    adapterMd: TASK_TEXT['role-delete.adapter.md'],
}
